// import { FinanceInventoryContextType } from "./finance-inventory-types";
import { DATE_TIME_FORMATS } from "../../../data/constants";
import moment from "moment";
export const ALLOWED_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "application/pdf"
];

export const MAX_FILE_SIZE_KB = 10240; // 10 MB

export const INVENTORY_ACTIVITY_NESTED_ROUTES = {
  root: "/",
  activityEdit: "activity-edit"
}

export const ITEMS_PER_PAGE = 10;

export const enum INVENTORY_ACTIVITY_STATUS {
  final = "Final",
  approved = "Approved",
  cancelled = "Cancelled",
  draft = "Draft",
}

export const INVENTORY_ACTIVITY_TYPES = {
  goods_received_note: "Goods Received Note",
  transfer_ins: "Transfer In",
  post_final_goods_received_note: "Post Final GRN",
  post_final_transfer_ins: "Post Final Transfer In",
};

// export const DEFAULT_FINANCE_INVENTORY_DATA: FinanceInventoryContextType = {
//   tempData: "",
//   currentActivityList: [],
//   onPageChange: () => {},
//   pageNumber: 1,
//   activityType: INVENTORY_ACTIVITY_TYPES.goods_received_note,
//   setActivityType: () => {},
//   resetPageData: () => {},
//   allPagesVisited: false,
//   setBranchId: () => {}
// };

export const TABLE_HEAD_KEYS = {
  date: "date",
  activity: "activity",
  orderId: "orderId",
  supplierName: "supplierName",
  branchInfo: "branchInfo",
  status: "status",
  isEdited: "isEdited",
  taxAmount: "taxAmount",
  billAmount: "billAmount",
  supplierInvoiceNumber: "supplierInvoiceNumber"
};

export const ACTIVITY_DETAIL_TABLE_HEADER_KEYS = {
  name: "name",
  quantity: "quantity",
  rate: "rate",
  taxes: "taxes",
  amount: "amount",
}

export const ACTIVITY_EDIT_TABLE_HEADER_KEYS = {
  name: "name",
  quantity: "quantity",
  rate: "rate",
}

export const IS_PAGE_RELOADED_KEY = "IS_PAGE_RELOADED_KEY"

export const ACTIVITY_DROPDOWN_TYPES = [{
  text: "Goods Received Note",
  value: INVENTORY_ACTIVITY_TYPES.goods_received_note,
},
{
  text: "Transfer In",
  value: INVENTORY_ACTIVITY_TYPES.transfer_ins,
},
{
  text: "Goods Received Note - Approved",
  value: INVENTORY_ACTIVITY_TYPES.post_final_goods_received_note,
},
{
  text: "Transfer In-Approved",
  value: INVENTORY_ACTIVITY_TYPES.post_final_transfer_ins,
}]

export const ACTIVITY_DROPDOWN_STATUS : Record<string, { text: string; value: string }> = {
  all: { text: "All", value: "All" },
  yes: { text: "Approved", value: "yes" },
  no: { text: "Rejected", value: "no" },
  pending: { text: "Pending", value: "pending" }
}

export const ACTIVITY_MODIFIED_STATUS : Record<string, { text: string; value: string }> = {
  all: { text: "All", value: "All" },
  yes: { text: "Yes", value: "yes" },
  no: { text: "No", value: "no" }
}

export const optionsDataForFilter = [
  {
    value: 'Today',
    totalDays: 0
  },
  {
    value: 'Yesterday',
    totalDays: 1
  },
  {
    value: 'Last Week',
    totalDays: 6
  },
  {
    value: 'Last Month',
    totalDays: 30,
  },
  {
    value: 'Custom Range',
    totalDays: 31
  }
]

export const enum INVENTORY_APPROVED_VALUES {
  all = "All",
  yes = "yes",
  no = "no",
  pending = "pending"
}
export const CURRENT_DATE = moment().format(DATE_TIME_FORMATS.dayMonthYear);

export const enum POST_FINAL_STAGE_STATUS {
  approved = "Approved",
  rejected = "Rejected",
  pending = "Pending"
}
